import { analytics } from '~/common';

import { useRunOnlyOnce } from './useRunOnlyOnce';

export const useSendContentCompletedEvent = ({ contentId }: { contentId: string }) => {
  const sendEventOnce = useRunOnlyOnce(() => analytics.sendContentCompleted(), [contentId]);
  return {
    onCompletionPercent: (completionPercent: number) => completionPercent > 75 && sendEventOnce(),
  };
};
